import { YANDEX_METRIKA_ID } from 'configs/env';

import { BaseAnalyticsStore } from '../BaseAnalyticsStore';

type SendEventFunc = (event: string, payload?: Record<string, any>) => void;

export class YmStore extends BaseAnalyticsStore<SendEventFunc> {
  readonly _analyticsTargetName = 'YandexMetrika';

  sendEvent = (event: string, payload?: Record<string, unknown>) => {
    try {
      if (window.ym) {
        window.ym(YANDEX_METRIKA_ID, 'reachGoal', event, payload);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e, 'error send event ym');
    }
  };
}
